module.exports = __webpack_public_path__ + "static/media/wmsui32_5087.39a825bf.ico";